import { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import './PrivacyPolicy.css';

function PrivacyPolicy() {
  const [content, setContent] = useState('');

  useEffect(() => {
    window.scrollTo(0, 0);
    fetch('/privacy_policy.md')
      .then((res) => res.text())
      .then((text) => setContent(text));
  }, []);

  return (
    <div className="privacy-policy">
      <div className="privacy-policy-container">
        <ReactMarkdown>{content}</ReactMarkdown>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
